import React, {Fragment} from 'react'
import { Timeline, List, Avatar, Table } from 'antd'
import moment from 'moment'
import styles from './index.less'


const DemandList = ({ data }) => {
  const columns = [
    {
      dataIndex: 'complain',
      title: '主诉',
      width: 200,
    },
    {
      dataIndex: 'dissent',
      title: '潜在异议',
    },
    {
      dataIndex: 'comment',
      title: '备注',
      width: 140,
    },
    {
      dataIndex: 'company',
      title: '家属陪同',
      width: 80,
      align: 'center',
      render(text) {
        return text ? '是' : '否'
      }
    },
    {
      dataIndex: 'createdAt',
      title: '创建时间',
      width: 140,
      align: 'center',
      render(text) {
        return text ? moment(text).format('YYYY-MM-DD HH:mm') : ''
      }
    },
    // {
    //   dataIndex: 'operation',
    //   title: '操作',
    //   width: 100,
    //   align: 'center',
    //   render(text, record) {
    //     return <Fragment>
    //       <a href="#" onClick={() => onEdit(record)}>编辑</a>
    //       <Divider type="vertical" />
    //       <a href="#">查看</a>
    //     </Fragment>
    //   }
    // }
  ]

  return (
    // <div className={styles.demand}>
    //   <Timeline>
    //     {data.map(_ => 
    //       <Timeline.Item key={_.createTime}>
    //         <p>{_.createTime}</p>
    //         <div className={styles.demandBlock}>
    //           <div>
    //             <p className="demandFst">医助：{_.assistant} {_.type}</p>
    //             {_.complaint && <p>主诉：{ _.complaint }</p> }
    //             {_.patientDemand && <p>来访者需求：{ _.patientDemand }</p> }
    //             {_.masterDemand && <p>决策人需求：{ _.masterDemand }</p> }
    //             {_.objection && <p>潜在异议：{ _.objection }</p> }
    //           </div>
    //           <a>查看详情</a>
    //         </div>
    //       </Timeline.Item>
    //     )}
    //   </Timeline>
    // </div>
    <div className={styles.follow}>
      <Table
        columns={columns}
        dataSource={data}
        pagination={false}
        size="small"
        rowKey="id"
      />
    </div>
  )
}

export default DemandList